import { BookOpen } from "lucide-react";
import { useLearningResources } from "@/lib/api/hooks";
import { MessageResourcePicker } from "./MessageResourcePicker";
import { LearningResourcePreview } from "./LearningResourcePreview";

export function appendLearningLink(text: string, title: string, url: string) {
  return `${text.trimEnd()}${text.trim() ? "\n\n" : ""}${title}\n${url}`;
}

export function LearningLinkPicker({
  disabled = false,
  onSelect,
}: {
  disabled?: boolean;
  onSelect: (title: string, url: string) => void;
}) {
  const resources = useLearningResources();
  return (
    <MessageResourcePicker
      label="Learn link"
      icon={<BookOpen size={16} aria-hidden />}
      title="Choose a Learn link"
      disabled={disabled}
      loading={resources.isLoading}
      failed={resources.isError}
      onRetry={() => void resources.refetch()}
      options={(resources.data ?? []).map((item) => ({
        id: item.url,
        title: item.title,
        description: item.snippet,
        category: item.kind === "guide" ? "Step-by-step guide" : "Article",
        searchText: item.category ?? "",
      }))}
      renderPreview={(id) => (
        <LearningResourcePreview
          resource={resources.data!.find((item) => item.url === id)!}
        />
      )}
      onSelect={(id) => {
        const resource = resources.data?.find((item) => item.url === id);
        if (resource) onSelect(resource.title, resource.url);
      }}
    />
  );
}
